/**
 * User roles in the system
 */
export const USER_ROLES = {
  ADMIN: 'ADMIN',
  ADMIN_ASSISTANT: 'ADMIN_ASSISTANT', // Read-only viewer with full visibility
  IM: 'IM', // Inbox Manager
  SDR: 'SDR', // Sales Development Representative
  AM: 'AM', // Account Manager
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

/**
 * Array of all valid roles
 */
export const VALID_ROLES = Object.values(USER_ROLES);